import React from 'react';
import UK from '../images/logo.png';
import Ceramic from '../images/ceramic.png';
import M_and_E from '../images/m_and_e.png';
import Facades from '../images/facades.png';

import {
  Card,
  // CardHeader,
  CardBody,
  // Button,
  CardTitle,
  CardText,
  CardImg
} from 'reactstrap';

export default function companyLinksBox() {
  return (
    <div>
      <div className='row justify-content-center'>
        <div className='col-10 col-sm-6 col-lg-3'>
          <Card className='my-4'>
            <div className='mx-4 mb-2'>
              <a href='http://www.sturminster.co.uk'>
                <CardImg src={UK} className='mt-4' alt='M&E Logo' />
              </a>
            </div>
            <CardBody>
              <CardTitle>
                <strong>Construction and Fit Outs</strong>
              </CardTitle>
              <ul>
                <CardText>
                  <li>Construction</li>
                  <li>Fit Outs</li>
                  <li>Refurbishments</li>
                  <li>Minor Works</li>
                </CardText>
              </ul>
            </CardBody>
          </Card>
        </div>
        <div className='col-10 col-sm-6 col-lg-3'>
          <Card className='my-4'>
            <div className='mx-4 mb-2'>
              <a href='http://www.sturminsterelectrical.co.uk'>
                <CardImg src={M_and_E} className='mt-4' alt='M&E Logo' />
              </a>
            </div>
            <CardBody>
              <CardTitle>
                <strong>Mechanical and Electrical</strong>
              </CardTitle>{' '}
              <ul>
                <CardText>
                  <li>Electrical</li>
                  <li>Heating</li>
                  <li>Ventilation</li>
                  <li>Plumbing</li>
                </CardText>{' '}
              </ul>
            </CardBody>
          </Card>
        </div>
        <div className='col-10 col-sm-6 col-lg-3'>
          <Card className='my-4'>
            <div className='mx-4 mb-2'>
              <a href='http://www.sturminsterfacades.co.uk'>
                <CardImg src={Facades} className='mt-4' alt='M&E Logo' />
              </a>
            </div>
            <CardBody>
              <CardTitle>
                <strong>Shopfronts and Cladding</strong>
                <br />
              </CardTitle>
              <ul>
                <CardText>
                  <li>Shopfronts</li>
                  <li>Glazing</li>
                  <li>Auto doors</li>
                  <li>Cladding</li>
                </CardText>
              </ul>
            </CardBody>
          </Card>
        </div>
        <div className='col-10 col-sm-6 col-lg-3'>
          <Card className='my-4'>
            <div className='mx-4 mb-2'>
              <a href='http://www.sturminsterceramic.co.uk'>
                <CardImg src={Ceramic} className='mt-4' alt='M&E Logo' />
              </a>
            </div>
            <CardBody>
              <CardTitle>
                <strong>Floor and Wall Tiling</strong>
              </CardTitle>

              <ul>
                <CardText>
                  <li>Floor Tiling</li>
                  <li>Wall Tiling</li>
                  <li>Vibro Floors</li>
                  <li>Floor Screeds</li>
                </CardText>
              </ul>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
